import * as React from 'react';
import { ArchetypeSpecificStepRunSummaryPanelProps } from '.';

export const ScreenshotsStepRunSummaryPanel: React.FC<ArchetypeSpecificStepRunSummaryPanelProps> = ({ stepRun }) => {
    return <div>Screenshots Step Run Summary Panel - {stepRun.displayName || stepRun.stepId}</div>;
};
